module.exports = __webpack_public_path__ + "img/frame_3.a721757.png";